require('./HistoryModalFields.scss');

const React = require('react'),
    get = require('lodash/object').get,
    {map} = require('lodash/collection'),
    {PropTypes} = require('react'),
    {TextField} = require('material-ui'),
    {t} = require('services/i18nextWrapper');

const HistoryModalFields = React.createClass({displayName: "HistoryModalFields",

    propTypes: {
        history: PropTypes.object
    },

    _el: null,

    _ref(el) {
        this._el = el;
    },

    _getHeaderColumns(fieldChanges) {
        const {oldValue} = get(fieldChanges, '0');
        return (
            React.createElement("div", {className: "bp-history-modal-fields__header row"}, 
                React.createElement("div", {className: "bp-history-modal-fields__header-column col-xs-4"}, 
                    React.createElement("strong", null, t('history_modal_fields_field_name'))
                ), 
                
                    oldValue ? (
                        React.createElement("div", {className: "bp-history-modal-fields__header-column col-xs-4"}, 
                            React.createElement("strong", null, t('history_modal_fields_old_value'))
                        )
                    ) : null, 
                
                React.createElement("div", {className: "bp-history-modal-fields__header-column col-xs-4"}, 
                    React.createElement("strong", null, t('history_modal_fields_new_value'))
                )
            )
        );
    },

    _getFieldEl(fieldChanges) {
        return map(fieldChanges, change => {
            const {newValue, oldValue, displayName} = change;
            return (
                React.createElement("div", {className: "bp-history-modal-fields row"}, 
                    React.createElement("div", {className: "bp-history-modal-fields__field bp-history-modal-fields__field-name col-xs-4"}, 
                        React.createElement(TextField, {
                            disabled: true, 
                            defaultValue: displayName }
                        )
                    ), 
                    
                        oldValue ? (
                            React.createElement("div", {
                                className: "bp-history-modal-fields__field bp-history-modal-fields__field-value col-xs-4"}, 
                                React.createElement(TextField, {
                                    defaultValue: oldValue, 
                                    disabled: true}
                                )
                            )
                        ) : null, 
                    
                    React.createElement("div", {className: "bp-history-modal-fields__field bp-history-modal-fields__field-value col-xs-4"}, 
                        React.createElement(TextField, {
                            disabled: true, 
                            defaultValue: newValue }
                        )
                    )
                )
            );
        });
    },

    render() {
        const fieldChanges = get(this.props, 'history.fieldChanges');
        const fieldsEl = this._getFieldEl(fieldChanges);
        const headersEl = this._getHeaderColumns(fieldChanges);
        return (
            React.createElement("div", {className: "bp-history-modal-fields__content"}, 
                headersEl, 
                fieldsEl
            )
        );
    }
});

module.exports = HistoryModalFields;



/** WEBPACK FOOTER **
 ** ./src/views/HistoryAdmin/HistoryModal/HistoryModalFields.jsx
 **/